import script from "./CodeSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeSection.vue?vue&type=script&setup=true&lang=js"

import "./CodeSection.vue?vue&type=style&index=0&id=50d0aa0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50d0aa0d"]])

export default __exports__